import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { PagePublicOrderWidgetComponent } from './page-public-order-widget/page-public-order-widget.component';

const routes: Routes = [
    { path: ':nom-position-uuid', component: PagePublicOrderWidgetComponent },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class PublicOrderWidgetRoutingModule {
}
